<template>
  <roe-error-message :field="design.employer_match_yos_vary_ee">
    <roe-radio-input
      value1="yes"
      value2="no"
      :disabled-yes="design.$model.match_contrib_based_yos_yesno === 1"
      v-model="design.$model.employer_match_yos_vary_ee"
      @change=resetYearsOfService
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import { EmployerMatchMixin } from "@/components/_shared/inputs/design/_mixins";
export default {
  name: "RoeEmployerMatchYosVaryEeRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [EmployerMatchMixin],
  props: {
    design: Object
  },
  methods: {
    resetYearsOfService() {
      if (this.design.$model.employer_match_yos_vary_ee === "no")
        this.design.$model.tiers.forEach(tier => (tier.yos_upper_limit = null));
    }
  }
};
</script>
